import { GiHumanPyramid } from "react-icons/gi";
import { GoTasklist } from "react-icons/go";
import { IoCallOutline, IoCogOutline } from "react-icons/io5";
import { MdCrisisAlert } from "react-icons/md";
import { SiCivicrm, SiGooglemeet } from "react-icons/si";

const sidebar = [
  {
    titleKey: "nav.home",
    title: "Home",
    icon: <SiCivicrm />,
    link: '/crm/home',
    permission: 'crm.home'
  },
  {
    titleKey: "sidebar.leads",
    title: "Leads",
    icon: <MdCrisisAlert />,
    link: '/crm/leads',
    permission: 'crm.leads.view'
  },
  {
    titleKey: "sidebar.customers",
    title: "Customers",
    icon: <GiHumanPyramid />,
    link: '/crm/customers',
    permission: 'crm.customers.view'
  },
  {
    titleKey: "sidebar.calls",
    title: "Calls",
    icon: <IoCallOutline />,
    link: '/crm/calls',
    permission: 'crm.calls.view'
  },
  {
    titleKey: "sidebar.tasks",
    title: "Tasks",
    icon: <GoTasklist />,
    link: '/crm/tasks',
    permission: 'crm.tasks.view'
  },
  {
    titleKey: "sidebar.meetings",
    title: "Meetings",
    icon: <SiGooglemeet />,
    link: '/crm/meetings',
    permission: 'crm.meetings.view'
  },
  {
    titleKey: "sidebar.crmSettings",
    title: "Settings",
    icon: <IoCogOutline />,
    link: '/crm/settings',
    permission: 'crm.settings.manage',
    fixedBottom: true
  }
];

export default sidebar;
